import { render, staticRenderFns } from "./distributionBox.vue?vue&type=template&id=008d4fdc&scoped=true"
import script from "./distributionBox.vue?vue&type=script&lang=js"
export * from "./distributionBox.vue?vue&type=script&lang=js"
import style0 from "./distributionBox.vue?vue&type=style&index=0&id=008d4fdc&prod&lang=scss&scoped=true"
import style1 from "./distributionBox.vue?vue&type=style&index=1&id=008d4fdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d4fdc",
  null
  
)

export default component.exports